import type { FC } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import type { SectionLink } from "@snapchat/snap-design-system";
import { GlobalNav } from "@snapchat/snap-design-system";
import { ExternalLinkIcon } from "@snapchat/snap-design-system-icons";
import { Flexbox } from "../Flexbox";
import { SnapchatGhost } from "../SnapchatGhost";
import { sectionStyle } from "../side-navigation/SideNavigation.styles";
import { DOCS_LINK } from "../constants/links";
import type { SideNavItems } from "../side-navigation/SideNavigation";
import type { useCaseType } from "../../use-case/types";
import { filterSearchParamsWhenNavigating } from "../../searchParams/filterSearchParams";
import {
    docsLinkStyle,
    drawerListItemClassName,
    leftContentStyle,
    titleStyle,
    globalNav,
    drawerClassName,
} from "./LeftContent.styles";

interface SectionLinkItems extends SectionLink {
    useCaseType: useCaseType;
}

export const LeftContent: FC<{ items: SideNavItems[] }> = ({ items }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const sectionLinks: SectionLinkItems[] = items.map((item) => {
        return { id: item.itemKey, displayName: item.text, url: item.itemKey, useCaseType: item.useCaseType };
    });
    const sampleGroupSection = sectionLinks.filter((item) => item.useCaseType === "sample");
    const testGroupSection = sectionLinks.filter((item) => item.useCaseType === "test");

    return (
        <>
            <div css={globalNav}>
                <GlobalNav
                    onLinkClick={(pathname) => {
                        navigate({ pathname, search: filterSearchParamsWhenNavigating(location.search) });
                    }}
                    mode="drawer"
                    drawerContainer="#route-container"
                    drawerClassName={drawerClassName}
                    drawerTopContent={
                        <Flexbox>
                            <a css={docsLinkStyle} href={DOCS_LINK} target="_blank">
                                Open Docs &nbsp; <ExternalLinkIcon size={16} />
                            </a>
                        </Flexbox>
                    }
                    linkClassName={drawerListItemClassName}
                    selectedLinkId={location.pathname.slice(1)}
                    sections={[
                        { name: <div css={sectionStyle}>Web SDK Testing</div>, links: testGroupSection },
                        { name: <div css={sectionStyle}>Sample Use Cases</div>, links: sampleGroupSection },
                    ]}
                />
            </div>
            <Flexbox css={leftContentStyle} alignItems="center">
                <SnapchatGhost />
                <div css={titleStyle}>Camera Kit Web Samples</div>
            </Flexbox>
        </>
    );
};
